import { Center, Loader } from '@mantine/core';

export const LoadingPage = () => {
  return (
    <Center h="100vh">
      <Loader size="lg" />
    </Center>
  );
};
